<i18n>
{
  "en": {
    "nextLabel": "Next",
    "moreLabel": "more"
  },
  "es": {
    "nextLabel": "Siguiente",
    "moreLabel": "más"
  }
}
</i18n>

<template>
  <v-snackbar v-if="!!currentNotification"
              :value=true
              :timeout=-1
              :color=currentNotification.color
              :absolute=currentNotification.absolute
              :top=currentNotification.top
              :right=currentNotification.right
              :bottom=currentNotification.bottom
              :left=currentNotification.left
              :multi-line=currentNotification.multiLine
              :vertical=currentNotification.vertical
              content-class="d-flex align-center justify-space-between"
  >
    <template v-for="(message, index) in currentNotification.messages">
      {{ message }}<br :key="index" v-if="isNotLastMessage(currentNotification.messages.length, index)">
    </template>
    <v-btn v-if="moreThanOneNotification" text color="white" raised @click="removeDefaultNotification">
      {{ nextNotificationMessage }}
    </v-btn>
    <v-btn v-else icon color="white" @click="removeDefaultNotification(currentNotification.id)" raised>
      <v-icon dense small>fa-times</v-icon>
    </v-btn>
  </v-snackbar>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { BEHAVIOUR, BEHAVIOUR_TYPES } from '../config';
import { notificationMixin } from '../mixins';

export default {
  name: 'un-notifications-queue',
  mixins: [notificationMixin],
  data() {
    return {
      currentNotification: null,
      currentTimeout: null,
      notificationsQueue: []
    };
  },
  computed: {
    ...mapGetters(['notifications']),
    moreThanOneNotification() {
      return this.notificationsQueue.length > 1;
    },
    nextNotificationMessage() {
      return `(${this.$t('nextLabel')} ${this.notificationsQueue.length - 1} ${this.$t('moreLabel')})`;
    },
    notificationsLength() {
      return this.notifications.length;
    },
    notificationsQueueLength() {
      return this.notificationsQueue.length;
    },
  },
  methods: {
    ...mapActions(['removeNotification']),
    async removeDefaultNotification() {
      this.notificationsQueue = this.notificationsQueue.filter(({ id }) => id !== this.currentNotification.id);
      if (this.currentNotification && this.currentNotification.onRemove && typeof this.currentNotification.onRemove === 'function') {
        this.currentNotification.onRemove();
      }
      this.currentNotification = null;
    },
    getNextNotificationToShow() {
      const currentNotificationIndex = BEHAVIOUR === BEHAVIOUR_TYPES.QUEUE ? 0 : this.notificationsQueue.length - 1;
      return this.notificationsQueue[currentNotificationIndex];
    },
  },
  watch: {
    async notificationsLength(updatedLength, previousLength) {
      if (updatedLength > previousLength) {
        const candidatesItemsToAdd = this.notifications.slice(previousLength, updatedLength);

        // Get only notification with different id
        const currentNotificationsIds = new Set(this.notificationsQueue.map(({ id }) => id));
        const itemsToAdd = candidatesItemsToAdd.filter(({ id }) => !currentNotificationsIds.has(id));
        this.notificationsQueue.push(...itemsToAdd);

        // Remove from buffer processed notifications
        await this.removeNotification(candidatesItemsToAdd.length);
      }
    },
    notificationsQueueLength(updatedLength, previousLength) {
      if (previousLength === 0) { // We need to show first item in the inner data structure
        // If the first item has been added
        this.currentNotification = this.getNextNotificationToShow();
        if (this.currentNotification.timeout) {
          this.currentTimeout = setTimeout(this.removeDefaultNotification, this.currentNotification.timeout);
        }
      } else if (updatedLength < previousLength && updatedLength !== 0) {
        // If a notification has been removed
        this.currentNotification = this.getNextNotificationToShow();
        if (this.currentNotification.timeout) {
          if (this.currentTimeout) clearTimeout(this.currentTimeout);
          this.currentTimeout = setTimeout(this.removeDefaultNotification, this.currentNotification.timeout);
        }
      }
    }
  }
};
</script>
